import { useState } from 'react';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../../contexts/AuthContext';
import { TextField, Button, Checkbox, FormControlLabel, Alert, Typography, Container, Box, Link, CircularProgress } from '@mui/material';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  const { signIn } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();
  
  const from = location.state?.from?.pathname || '/';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email || !password) {
      setError('Veuillez remplir tous les champs');
      return;
    }

    try {
      setError('');
      setIsLoading(true);
      await signIn(email, password);
      navigate(from, { replace: true });
    } catch (err: any) {
      console.error('Erreur de connexion:', err);
      setError('Identifiants invalides ou compte inexistant');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxWidth="xs" sx={{ py: 8 }}>
      <Box textAlign="center" mb={4}>
        <Typography component="h2" variant="h4" fontWeight={700} gutterBottom>
          Connexion à votre compte
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Ou{' '}
          <Link component={RouterLink} to="/register" underline="hover" color="primary">
            créez un nouveau compte
          </Link>
        </Typography>
      </Box>
      <Box>
        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>
        )}
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Adresse email"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Mot de passe"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Box display="flex" alignItems="center" justifyContent="space-between" mt={1} mb={2}>
            <FormControlLabel
              control={<Checkbox color="primary" />}
              label="Se souvenir de moi"
            />
            <Link component={RouterLink} to="/forgot-password" variant="body2" color="primary">
              Mot de passe oublié ?
            </Link>
          </Box>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            size="large"
            disabled={isLoading}
            sx={{ mt: 2, mb: 2, fontWeight: 700 }}
            startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
          >
            {isLoading ? 'Connexion en cours...' : 'Se connecter'}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default Login;
